"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactLoadingSkeleton = require("react-loading-skeleton");
var _variables = require("../../styles/variables");
var _SkeletonWrapperStyled = require("./SkeletonWrapperStyled");
var _jsxRuntime = require("react/jsx-runtime");
const SkeletonWrapper = _ref => {
  let {
    showChildren = false,
    children = null,
    margin = '',
    width = null,
    ...props
  } = _ref;
  return showChildren ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: children
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapperStyled.SkeletonWrapperStyled, {
    width: width,
    margin: margin,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.SkeletonTheme, {
      baseColor: _variables.LoaderColor,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapperStyled.StyledSkeleton, {
        ...props
      })
    })
  });
};
var _default = exports.default = SkeletonWrapper;